













 





















const node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "templateId",
    "variableName": "templateId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ReflectTemplate",
  "kind": "LinkedField",
  "name": "reflectTemplate",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedTemplateId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ReflectTemplate",
  "kind": "LinkedField",
  "name": "selectedTemplate",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveReflectTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveReflectTemplatePayload",
        "kind": "LinkedField",
        "name": "removeReflectTemplate",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RetrospectiveMeetingSettings",
            "kind": "LinkedField",
            "name": "retroMeetingSettings",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveReflectTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveReflectTemplatePayload",
        "kind": "LinkedField",
        "name": "removeReflectTemplate",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RetrospectiveMeetingSettings",
            "kind": "LinkedField",
            "name": "retroMeetingSettings",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "m_8iS-3MfRh-XrB00XPJpBeA",
    "metadata": {},
    "name": "RemoveReflectTemplateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "24d8830bec9ff3b73cff8c2148b45df5";

export default node;
